import { ca } from '@cian/analytics';

import { OFFERS_ON_PAGE, trackingReasonToListingType } from '../constants';
import { ITrackOfferActionsProps } from '../types';

export function trackAddFavorite({
  offerPosition,
  offerId,
  offersLength,
  pageNumber,
  gaLabel,
  reason,
  jsonQuery,
  queryString,
  deviceType,
  isCianPartner,
  partnerUrl,
}: ITrackOfferActionsProps) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: deviceType === 'desktop' ? 'add_from_newlist' : 'add_from_list_mob',
    label: gaLabel,
    page: {
      pageType: 'Listing',
      listingType: trackingReasonToListingType[reason],
      offersQty: offersLength < OFFERS_ON_PAGE ? offersLength : OFFERS_ON_PAGE,
      pageNumber,
      extra: {
        reason,
        mobileWebsiteType: 'new',
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    products: [
      {
        id: offerId,
        position: offerPosition,
        offerType: 'offer',
        extra: { isPartner: isCianPartner, partner_url: partnerUrl },
      },
    ],
    sc: jsonQuery,
  });
}
